import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    SINGLE: {
        id: 'phoneMartialStatus.SINGLE',
        defaultMessage: 'Single',
    },
    MARRIED: {
        id: 'phoneMartialStatus.MARRIED',
        defaultMessage: 'Married',
    },
    DIVORCED: {
        id: 'phoneMartialStatus.DIVORCED',
        defaultMessage: 'Divorced',
    },
    WIDOWER: {
        id: 'phoneMartialStatus.WIDOWER',
        defaultMessage: 'Widower',
    },
    PREFER_NOT_TO_SAY: {
        id: 'phoneMartialStatus.PREFER_NOT_TO_SAY',
        defaultMessage: 'Prefer not to say',
    },
});

export default enumMessages;
